var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 115,
    viewBox: "0 0 323 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.667 6C311.667 8.94552 314.054 11.3333 317 11.3333C319.946 11.3333 322.333 8.94552 322.333 6C322.333 3.05448 319.946 0.666667 317 0.666667C314.054 0.666667 311.667 3.05448 311.667 6ZM0 115H152V113H0V115ZM193 74V46H191V74H193ZM232 7H317V5H232V7ZM193 46C193 24.4609 210.461 7 232 7V5C209.356 5 191 23.3563 191 46H193ZM152 115C174.644 115 193 96.6437 193 74H191C191 95.5391 173.539 113 152 113V115Z",
    fill: "url(#paint0_linear_4072_7271)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4072_7271",
    x1: 309.5,
    y1: 1.00003,
    x2: 20,
    y2: 1.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B448",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector_2.07608a6ff0084566b9a21c5967d7f02f.svg";
export { ForwardRef as ReactComponent };